import React, { useState } from "react";
import HeadingView from "common/views/heading/Heading.view";
import { ImageVariant, ImageView } from "common/views/image/Image.view";
import { Fragment } from "core/components/FragmentProvider";
import { Article } from "./entities";
import * as articleActions from "./arcticleActions";
import { Tab, Tabs } from "@blueprintjs/core";
import ArticleGlossary from "../ArticleGlossary";
import AttachmentList from "../AttachmentList";
import { ArticleContributorList } from "../articleContributor/ArticleContributorList";
import * as articleFragments from "./articleFragments";
import { FragmentLayout } from "../../../core/components/FragmentLayout";
import * as commonFragments from "./commonFragments";

interface IArticleEditFragmentProps {
	article: Article;
	onChange: (article: Article) => void;
	uiSchema: any;
	actions?: typeof articleActions;
	contributorDisplay?: JSX.Element;
	attachmentDisplay?: JSX.Element;
	config?: any;
}

export const Menu: Fragment<IArticleEditFragmentProps> = {
	name: "Menu",
	component: (props) => {
		const [navbarTabID, setNavbarTabID] = useState("article");
		const handleTabChange = (navbarTabID: any) => {
			setNavbarTabID(navbarTabID);
		};

		return (
			<React.Fragment>
				<Tabs
					id="TabsExample"
					selectedTabId={navbarTabID}
					onChange={handleTabChange}
				>
					<Tab
						id="article"
						title="Article"
						panel={
							<React.Fragment>
								<hr style={{ minWidth: "500px" }} />
								<FragmentLayout
									layout={props.config.layout}
									fragments={{
										...articleFragments,
										...commonFragments,
									}}
									props={{
										article: props.article,
									}}
								/>
							</React.Fragment>
						}
					/>
					<Tab
						id="attachments"
						title="Attachments"
						panel={
							<React.Fragment>
								<hr style={{ minWidth: "500px" }} />
								<AttachmentList
									article={props.article}
									config={props.config}
								/>
							</React.Fragment>
						}
					/>
					<Tab
						id="contributors"
						title="Contributors"
						panel={
							<React.Fragment>
								<hr style={{ minWidth: "500px" }} />
								<ArticleContributorList
									article={props.article}
									config={props.config}
								/>
							</React.Fragment>
						}
					/>
					<Tab
						id="glossary"
						title="Glossary"
						panel={
							<React.Fragment>
								<hr style={{ minWidth: "500px" }} />
								<ArticleGlossary
									article={props.article}
									config={props.config}
								/>
							</React.Fragment>
						}
					/>
				</Tabs>
			</React.Fragment>
		);
	},
};

export const title: Fragment<IArticleEditFragmentProps> = {
	name: "Title",
	component: (props) => (
		<HeadingView viewKey="article.title">{props.article.name}</HeadingView>
	),
};

export const icon: Fragment<IArticleEditFragmentProps> = {
	name: "Icon",
	component: (props) => (
		<ImageView
			viewKey="article.icon"
			variant={ImageVariant.ICON}
			src={props.article.iconUrl}
		/>
	),
};



// WEBPACK FOOTER //
// ./src/panels/articleDetails/article/fragments.tsx